// removed by extract-text-webpack-plugin
module.exports = {"containerSelect":"index__containerSelect___3Fjen","invalid":"index__invalid___2OKTV","label":"index__label___h-7Ak","error":"index__error___3H0EJ","margin_top_0":"index__margin_top_0___10cRc","margin_top_3":"index__margin_top_3___1bebX","margin_top_4":"index__margin_top_4___38eVL","margin_top_5":"index__margin_top_5___30iah"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/skin/styles/ModernSelect/index.css
// module id = 1270
// module chunks = 0